/* import __COLOCATED_TEMPLATE__ from './conversation-sla-applied-by-workflow.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type IntlService from 'embercom/services/intl';
import {
  truncateEventText,
  isEventTextTruncated,
  FEATURE_FLAG_NAME,
} from 'embercom/lib/inbox2/event-text-truncation';

interface Signature {
  Args: any;
}

export default class ConversationSlaAppliedByWorkflowComponent extends Component<Signature> {
  @service declare session: Session;
  @service declare intl: IntlService;

  get isConversationEventsUiImprovementsEnabled(): boolean {
    return this.session.workspace?.isFeatureEnabled(FEATURE_FLAG_NAME) ?? false;
  }

  get translationKey(): string {
    return this.isConversationEventsUiImprovementsEnabled
      ? 'inbox.conversation-sla-applied-by-workflow.rule-sla-changed-v2'
      : 'inbox.conversation-sla-applied-by-workflow.rule-sla-changed';
  }

  /**
   * Returns the SLA part of the event (e.g., 'SLA: "{sla}" ').
   * Used when both SLA and workflow are truncated so each can have its own IcTooltip.
   */
  get slaPart(): string {
    return this.intl.t('inbox.conversation-sla-applied-by-workflow.sla-part-v2', {
      sla: truncateEventText(this.args.part.renderableData.conversationSla.label),
    });
  }

  /**
   * Returns the workflow part of the event (e.g., 'applied by Workflow "{workflow}"').
   * Used when both SLA and workflow are truncated so each can have its own IcTooltip.
   */
  get workflowPart(): string {
    return this.intl.t('inbox.conversation-sla-applied-by-workflow.workflow-part-v2', {
      workflow: truncateEventText(this.args.part.renderableData.workflow.label),
    });
  }

  truncateTitle(title: string | undefined): string {
    return truncateEventText(title);
  }

  isTitleTruncated(title: string | undefined): boolean {
    return isEventTextTruncated(title);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::ConversationSlaAppliedByWorkflow': typeof ConversationSlaAppliedByWorkflowComponent;
    'inbox2/conversation-stream/event-parts/conversation-sla-applied-by-workflow': typeof ConversationSlaAppliedByWorkflowComponent;
  }
}
